import { ShoppingCart } from "lucide-react";
import { ShoppingItem } from "./ShoppingItem";

export function ShoppingList({
  groupedItems,
  categoryColors,
  onToggleItem,
  onEditItem,
  onDeleteItem,
}) {
  if (Object.keys(groupedItems).length === 0) {
    return (
      <div className="card-base p-12 text-center">
        <ShoppingCart className="w-16 h-16 mx-auto mb-4 text-slate-600" />
        <p className="text-slate-400 text-lg">Shopping list is empty</p>
        <p className="text-slate-500 text-sm mt-1">
          Add items you need to buy
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {Object.entries(groupedItems).map(([category, categoryItems]) => (
        <div key={category} className="card-base p-5">
          <div className="flex items-center gap-2 mb-4">
            <div
              className="w-3 h-3 rounded-full"
              style={{ backgroundColor: categoryColors[category] }}
            />
            <h2 className="text-lg font-semibold text-white font-['Outfit']">
              {category}
            </h2>
            <span className="text-sm text-slate-500">
              ({categoryItems.filter((i) => !i.checked).length})
            </span>
          </div>

          <div className="space-y-2">
            {categoryItems.map((item) => (
              <ShoppingItem
                key={item.id}
                item={item}
                onToggle={onToggleItem}
                onEdit={onEditItem}
                onDelete={onDeleteItem}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
